<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="svgexport-20 1">
      <path
        id="Vector"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 5H8.25V6H20.25V8H8.25V9H6.25V8H4.25V6H6.25V5ZM18.25 13H20.25V11H18.25V10H16.25V11H4.25V13H16.25V14H18.25V13ZM12.3108 18H20.25V16H12.3108V15H10.3108V16H4.25V18H10.3108V19H12.3108V18Z"
        fill="#111111"
      />
    </g>
  </svg>
</template>
